// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3jRQo","selected":"Chip_selected__3HmfJ"};